<script lang='ts'>
import type { Rank } from "../services";

export let rank: Rank;

function suffix(i) {
  let j = i % 10,
      k = i % 100;
  if (j == 1 && k != 11) {
    return i + "st";
  }
  if (j == 2 && k != 12) {
    return i + "nd";
  }
  if (j == 3 && k != 13) {
    return i + "rd";
  }
  return i + "th";
}
</script>

<div class='col hcenter'>
  <div class="medal" style="background-image: url(img/rank-{rank.rank <= 3 ? rank.rank : 'other'}.png)">
    <div class="rank">{suffix(rank.rank)}</div>
  </div>

  <div class='name'>{rank.name}</div>
  <div class='row vcenter points'>
    {rank.points} <img src="/img/point.png" />
  </div>
</div>

<style>
.medal {
  position: relative;
  width: 150px;
  height: 170px;
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
}

.rank {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%);
  font-weight: bold;
}

.points, .name {
  font-weight: bold;
}

.points img {
  margin-left: 6px;
}
</style>